import { Navigate } from "react-router-dom";

import { useIsDemo } from "@/hooks/common/useIsDemo";
import { PATH_ROOT } from "@/routes/paths";

/** @deprecated Use /chat — Create is merged into Ask Ari home */
const CreatePage = () => {
  const isDemo = useIsDemo();
  return <Navigate to={isDemo ? PATH_ROOT.demo.chat : PATH_ROOT.main.chat} replace />;
};

export default CreatePage;
